<template>
  <div class="home">
    <SchoolMap/>
  </div>
</template>

<script>
// @ is an alias to /src
import SchoolMap from '@/components/SchoolMap/SchoolMap.vue'

export default {
  name: 'home',
  components: {
    SchoolMap
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit("SET_IS_FRONT", true);
      vm.$store.commit("UPDATE_MAP_KEY", true);
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit("SET_IS_FRONT", false);
    next();
  },
}
</script>
